window.addEventListener("load", function() {
  const allParallaxBgs = [
    ...document.querySelectorAll(".fl-row-bg-parallax .fl-row-content-wrap"),
  ];
  if (!allParallaxBgs) {
    return null;
  }
  function shouldParallax(screenSize) {
    if (screenSize.matches) {
      allParallaxBgs.forEach(function(bg) {
        bg.style.backgroundPosition = "center center";
      });
    } else {
      return null;
    }
  }

  var screenSize = window.matchMedia("(max-width: 763px)");
  shouldParallax(screenSize); // Call listener function at run time
  screenSize.addListener(shouldParallax); // Attach listener function on state changes
});
